// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"UploadFile_dropzone__1yya4","reject":"UploadFile_reject__6TM-k","accept":"UploadFile_accept__1nvFg","browse-button":"UploadFile_browse-button__gshy2"};